import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template"
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterUser_template} from "./filterUser_template";
import {filterTag_template} from "./filterTag_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";


declare var ko: any;

export class articlesList_template extends vnTemplate{

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected dateFilter: filterDate_template;
    protected authorFilter: filterUser_template;
    protected editorFilter: filterUser_template;
    protected statusFilter : multipleSelector_template;
    protected publishStatusFilter : multipleSelector_template;
    protected syncStatusFilter : multipleSelector_template;
    protected templateFilter : multipleSelector_template;
    protected classificationFilter : multipleSelector_template;
    protected intentFilter : multipleSelector_template;
    protected networkCategoryFilter : multipleSelector_template;
    protected contentTypeFilter : multipleSelector_template;
    protected categoryFilter : multipleSelector_template;
    protected tagFilter: filterTag_template;
    protected filterPreset: filterPreset_template;
    protected pageViews24HrsChart: amCharts_v4_date_line_template;
    protected shortTermReportChart: amCharts_v4_date_line_template;
    protected shortTermReportTooltip: infoButton_template;
    protected shortTermReportTooltipContent;

    protected getTemplateHtml(): string{

        return `
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">

                        ` + this.filterPreset.getHtmlBuild() + `
                </div>

                <div class="sub-header w-justify">

                    <div class="w-left">

                        ${ this.statusFilter.getHtmlBuild() }
                        ${ this.categoryFilter.getHtmlBuild() }
                        ${ this.contentTypeFilter.getHtmlBuild() }
                        ${ this.networkCategoryFilter.getHtmlBuild() }
                        ${ this.publishStatusFilter.getHtmlBuild() }
                        ${ this.syncStatusFilter.getHtmlBuild() }
                        ${ this.templateFilter.getHtmlBuild() }
                        <!-- ko if: permissions()['article_edit_publishingControl'].read -->
                        ${ this.classificationFilter.getHtmlBuild() }
                         <!-- /ko -->
                        ${ this.intentFilter.getHtmlBuild() }
                        ${ this.authorFilter.getHtmlBuild() }
                        ${ this.editorFilter.getHtmlBuild() }
                        ${ this.tagFilter.getHtmlBuild() }
                        ${ this.dateFilter.getHtmlBuild() }
                    </div>
                </div>

            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-authors"></div>
                   <div id="selected-editors"></div>
                   <div id="selected-article_statuses"></div>
                   <div id="selected-publish_statuses"></div>
                   <div id="selected-sync_statuses"></div>
                   <div id="selected-templates"></div>
                   <div id="selected-classifications"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-categories"></div>
                   <div id="selected-tags"></div>
                   <div id="selected-intents"></div>
                </div>
            </div>

            <div class="list-header w-justify">
               <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}, visible: isAddButtonShown" class="btn secondary icon i-add" type="button">Add Article</button>
                    <!-- ko if: permissions()['trash_articles_tool'].read -->
                    <button data-bind="event: {click: onClickToggleTrashedArticlesForm}" class="btn secondary icon i-delete" type="button">Trash Articles</button>
                    <!-- /ko -->
               </div>

               <div class="w-center">
                    ` + this.filter.getHtmlBuild() + `
               </div>

                <div class="w-right">

                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-show-hide-columns-btn">
                <button data-bind="event: {click: onClickShowEditColumnPreferences.bind($data, true) }" class="btn secondary icon i-view" type="button">Columns</button>
            </div>
            <div data-bind="css: { 'is-visible': isVisibleUpdateColumnPreferences }" class="w-lightbox light-theme show-hide-columns-lightbox">
                        <div class="lightbox-content">
                            <div class="w-form lightbox-form">
                                <div class="form-header">
                                    <h3 class="form-title">Choose which columns to show.</h3>
                                </div>

                                <div class="form-body">
                                    <div class="form-group">
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['dateUpdated'], checked: arrayShowColumns()['dateUpdated'], attr:{id: 'dateUpdated'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Date Updated', attr:{for: 'dateUpdated'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['dateScheduled'], checked: arrayShowColumns()['dateScheduled'], attr:{id: 'dateScheduled'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Scheduled Date', attr:{for: 'dateScheduled'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['dateOriginalPublish'], checked: arrayShowColumns()['dateOriginalPublish'], attr:{id: 'dateOriginalPublish'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Original Publish Date', attr:{for: 'dateOriginalPublish'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['dateLastPublish'], checked: arrayShowColumns()['dateLastPublish'], attr:{id: 'dateLastPublish'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Last Published Date', attr:{for: 'dateLastPublish'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['syncStatus'], checked: arrayShowColumns()['syncStatus'], attr:{id: 'syncStatus'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Sync Status', attr:{for: 'syncStatus'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['articleStatus'], checked: arrayShowColumns()['articleStatus'], attr:{id: 'articleStatus'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Article Status', attr:{for: 'articleStatus'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['template'], checked: arrayShowColumns()['template'], attr:{id: 'template'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Type', attr:{for: 'template'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['networkCategory'], checked: arrayShowColumns()['networkCategory'], attr:{id: 'networkCategory'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Network Category', attr:{for: 'networkCategory'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['intent'], checked: arrayShowColumns()['intent'], attr:{id: 'intent'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Intent', attr:{for: 'intent'}"></label>
                                        </div>
                                        <div class="multi-row">
                                            <input data-bind="value: arrayShowColumns()['contentType'], checked: arrayShowColumns()['contentType'], attr:{id: 'contentType'}" type="checkbox">
                                            <label class="form-label icon i-check" data-bind="text: 'Content Type', attr:{for: 'contentType'}"></label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-footer">
                                    <button type="button" data-bind="event: { click: onClickSaveColumnPreferences}" class="btn highlight">Save</button>
                                    <button type="button" data-bind="event: { click: onClickShowEditColumnPreferences.bind($data, false)}" class="btn ">Cancel</button>
                                </div>
                            </div>

                        </div>
                    </div>

            <div class="w-list-results list-article" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>

                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Article Name</span></th>
                            <th data-bind="visible: permissions()['article_list_brand'].read"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'author') }, css: { 'list-sort-desc': orderByAndDirection()=='author_DESC', 'list-sort-asc': orderByAndDirection()=='author_ASC' }">Author</span></th>
                            <th data-bind="visible: columnPreference()['networkCategory']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategory_ASC' }">Network Category</span></th>
                            <th data-bind="visible: columnPreference()['intent']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'intent') }, css: { 'list-sort-desc': orderByAndDirection()=='intent_DESC', 'list-sort-asc': orderByAndDirection()=='intent_ASC' }">Intent</span></th>
                            <th data-bind="visible: columnPreference()['contentType']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC' }">Content Type</span></th>
                            <th data-bind="visible: columnPreference()['template']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template') }, css: { 'list-sort-desc': orderByAndDirection()=='template_DESC', 'list-sort-asc': orderByAndDirection()=='template_ASC' }">Type</span></th>
                            <th data-bind="visible: columnPreference()['syncStatus']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'syncStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='syncStatus_DESC', 'list-sort-asc': orderByAndDirection()=='syncStatus_ASC' }">Sync Status</span></th>
                            <th data-bind="visible: columnPreference()['articleStatus']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='articleStatus_DESC', 'list-sort-asc': orderByAndDirection()=='articleStatus_ASC' }">Article Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'publishStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='publishStatus_DESC', 'list-sort-asc': orderByAndDirection()=='publishStatus_ASC' }">Publish Status</span></th>
                            <th data-bind="visible: columnPreference()['dateScheduled']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateScheduled') }, css: { 'list-sort-desc': orderByAndDirection()=='dateScheduled_DESC', 'list-sort-asc': orderByAndDirection()=='dateScheduled_ASC' }">Scheduled Date</span></th>
                            <th data-bind="visible: columnPreference()['dateLastPublish']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateLastPublish') }, css: { 'list-sort-desc': orderByAndDirection()=='dateLastPublish_DESC', 'list-sort-asc': orderByAndDirection()=='dateLastPublish_ASC' }">Last<br>Published Date</span></th>
                            <th data-bind="visible: columnPreference()['dateOriginalPublish']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateOriginalPublish') }, css: { 'list-sort-desc': orderByAndDirection()=='dateOriginalPublish_DESC', 'list-sort-asc': orderByAndDirection()=='dateOriginalPublish_ASC' }">Original<br>Publish Date</span></th>
                            <th data-bind="visible: columnPreference()['dateUpdated']"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            </tr>
                    </thead>
                    <tbody data-bind="foreach: articles">

                        <tr class="cursor" data-bind="css: { 'is-locked': $parent.lockedArticles().indexOf(id+'') !== -1 }">
                            <td class="flex" data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }">
                                    <span class="icon i-lock"></span>
                                    <span class="title" data-bind="text: title"></span>
                                    <a class="btn icon border only-icon i-link" data-bind="visible : $data['template'] !== 'Sub-Content' , event: { click: $parent.onClickViewOnSite }, attr: { id : 'site-view' + $data.id }"></a>
                                </a>
                            </td>
                            <td class="no-wrap" data-bind="event: { click: $parent.onClickView }, visible: $parent.permissions()['article_list_brand'].read, if: author"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }"><span data-bind="text: author"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['networkCategory'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }, if: networkCategory"><span data-bind="text: networkCategory || 'N/A'"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['intent'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }, if: intent"><span data-bind="text: intent"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['contentType'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }, if: contentType"><span data-bind="text: contentType"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['template'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }, if: template"><span data-bind="text: template"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['syncStatus'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }, if: syncStatus"><span data-bind="text: syncStatus"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['articleStatus'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }, if: articleStatus"><span data-bind="text: articleStatus"></span></a></td>
                            <td class="no-wrap" data-bind="event: { click: $parent.onClickView }, if: publishStatus"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }"><span data-bind="text: publishStatus"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['dateScheduled'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }"><span data-bind="text: dateScheduled == null ? '' : dateScheduled"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['dateLastPublish'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }"><span data-bind="text: dateLastPublish == null ? '' : dateLastPublish"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['dateOriginalPublish'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }"><span data-bind="text: dateOriginalPublish == null ? '' : dateOriginalPublish"></span></a></td>
                            <td data-bind="visible: $parent.columnPreference()['dateUpdated'], event: { click: $parent.onClickView }"><a data-bind="attr: { href :   '/brand/' + $parent.brand().id + '/articles/view/' + $data.id }"><span data-bind="text: dateUpdated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="list-references">
                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${this.pageViews24HrsChart.getHtmlBuild()}
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme performance-pop-up" id="articleList-chart">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width: 50vw">
                        <div class="form-header">
                          <h3 class="form-title">Performance
                              <span class="w-tooltips-adv pos-bottom short"  style="margin-left: 1rem;margin-top: -1rem;">
                                   ` + this.shortTermReportTooltip.getHtmlBuild() + `
                              </span>
                          </h3>
                          <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickHideChart }"></button>
                        </div>
                        <div class="form-body">
                        <div class="sentinel-logo"></div>
                            <div class="form-group w-justify" data-bind="visible: shortTermReportIsPublished()">
                                <div class="w-left">
                                    <div class="form-group row" style="margin: 0">
                                         <div class="form-check-inline width-auto">
                                            <input type="radio" name="ShortTermReportView" id="view_24hour" value="day" data-bind="checked: shortTermReportRange(), event: {change : onClick1DayView}"/>
                                            <label class="form-label" for="view_24hour">24 Hour View</label>
                                         </div>
                                         <div class="form-check-inline width-auto">
                                             <input type="radio" name="ShortTermReportView" id="view_7day" value="week" data-bind="checked: shortTermReportRange(), event: {change : onClick7DayView}"/>
                                             <label  class="form-label" for="view_7day">7 Day View</label>
                                         </div>
                                    </div>
                                </div>
                                <div class="w-center">
                                    <div id="legenddiv"></div>
                                </div>
                                <div class="w-right">
                                    <button title="Add to Watchlist" type="button" data-bind="visible: !isOnWatchlist(), enable: watchlistButtonEnabled(), event: { click: onClickEditWatchlist.bind($data, true)}" class="btn icon only-icon i-watchlist" style="margin-right: 1rem"></button>
                                    <button title="Remove From Watchlist" type="button" data-bind="visible: isOnWatchlist(), enable: watchlistButtonEnabled(), event: { click: onClickEditWatchlist.bind($data, false)}" class="btn icon only-icon i-watchlist-full" style="margin-right: 1rem"></button>

                                    <button type="button" data-bind="attr:{title: (lastRefreshedCounter() > 0 ? lastRefreshedCounter() + ' new datapoint(s) available' : 'Refresh')}, event: { click: onClickRefresh}" class="btn icon only-icon i-refresh">
                                        <span class="new-data-counter" data-bind="text: lastRefreshedCounter(), visible: lastRefreshedCounter() > 0"></span>
                                    </button>
                                </div>
                            </div>
                            <div class="form-group" id="shortTermReportFormGroup" style="height: 470px">
                                <div data-bind="visible: shortTermReportIsPublished()">
                                    ${this.shortTermReportChart.getHtmlBuild()}
                                </div>
                                <div class="form-group">
                                    <p class="form-text"  data-bind="visible: !shortTermReportIsPublished(), text:'This article has not yet been published to the website. There is no performance data available for it.'"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="trashed-article-form-dialog" class="w-lightbox light-theme" data-bind="css: { 'is-visible': trashedArticlesFormShown }">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title icon i-delete">Trash Articles</h3>
                            <button type="button"  data-bind="event: { click: onClickToggleTrashedArticlesForm }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body" data-bind="css : {'loading' : trashedArticlesFormIsLoading }">
                            <div class="form-group">

                                <!-- ko if: trashedArticlesFormError() -->
                                <ul id="data-trash-error"
                                    data-bind="foreach: { data: trashedArticlesFormError().messages, as: 'errorMessage' }"

                                >
                                    <li class="data-trash-error">ERROR <span data-bind="text : errorMessage"></span></li>
                                </ul>

                                <p>
                                   This tool allows for article trashing in bulk. CSV file uploads should contain a single
                                   column with an “id” header and values matching Emaki article IDs associated with the brand.
                                   Accepted files will be processed within an hour. Once processed, the website sync to remove
                                   the articles from the website will begin and duration will increase proportionally depending
                                   on the number of articles.
                                </p>
                                <!-- /ko -->
                                <form style="margin-top: 1rem">
                                    <input class="input-file-btn icon i-upload"
                                        type="file"
                                        id="csvFileInput"
                                        name="csvFileInput"
                                        accept=".csv"
                                        data-bind="event: { change: function() { onChangeTrashedArticlesForm($element) }}"
                                    />
                                </form>
                            </div>

                                <div class="form-group" id="trash-articles-summary">
                                <!-- ko if: trashedArticlesSummary() -->
                                    <div class="trash-articles-summary">
                                        <p>
                                            <span data-bind="text: trashedArticlesSummary().numberOfAffectedArticles + ' articles will have their publish status set to “unpublished” and their article status set to “trash”.' "></span>
                                            <!-- ko if: trashedArticlesSummary().numberOfArticlesAlreadyTrashed -->
                                            <br><span data-bind="text: trashedArticlesSummary().numberOfArticlesAlreadyTrashed + ' articles are already set to “trash” and will be skipped.' "></span>
                                            <!-- /ko -->
                                            <ul>
                                                <li>The impacted articles include
                                                <span data-bind="text: trashedArticlesSummary().numberOfUniqueNetworkCategories"></span> unique network categories,
                                                <span data-bind="text: trashedArticlesSummary().numberOfUniqueCategories"></span> unique categories,
                                                <span data-bind="text: trashedArticlesSummary().numberOfUniqueTags"></span> unique tags, and
                                                <span data-bind="text: trashedArticlesSummary().numberOfContentTypes"></span> unique content types.</li>
                                                <li>The oldest impacted article was originally published on <span data-bind="text: trashedArticlesSummary().oldestOriginalPublishDate"></span>.</li>
                                                <li>The newest impacted article was most recently published on <span data-bind="text: trashedArticlesSummary().newestDateMostRecentPublished"></span>.</li>
                                            </ul>
                                        </p>
                                    </div>
                                <!-- /ko -->
                                </div>

                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickToggleTrashedArticlesForm }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickUploadTrashedArticlesFiles } , enable : trashedArticlesSummary" class="btn highlight">Submit</button>
                        </div>
                    </div>

                </div>
            </div>

            `;
    }

    protected initPartial(): void{

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().startDate(null);
        this.dateFilter.getTemplateViewModel().endDate(null);
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setLabel('Date Range');

        this.authorFilter = new filterUser_template("authorFilter", this.getTemplateViewModel(), this.caller);
        this.authorFilter.asMultipleSelectionMode();
        this.authorFilter.setTagContainerId('selected-authors');
        this.authorFilter.setTagContainerCaption('Selected authors:');
        this.authorFilter.setPlaceholderText("Author");
        this.authorFilter.setUniqueIdentifier('authorId');
        this.authorFilter.setIsVisible(false);

        this.editorFilter = new filterUser_template("editorFilter", this.getTemplateViewModel(), this.caller);
        this.editorFilter.asMultipleSelectionMode();
        this.editorFilter.setTagContainerId('selected-editors');
        this.editorFilter.setTagContainerCaption('Selected editors:');
        this.editorFilter.setPlaceholderText("Editor");
        this.editorFilter.setUniqueIdentifier("editorId");

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("article status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-article_statuses');
        this.statusFilter.setTagContainerCaption('Selected article statuses:');

        this.publishStatusFilter = new multipleSelector_template("publishStatusFilter", this.getTemplateViewModel(), this.caller);
        this.publishStatusFilter.setLabel("publish status");
        this.publishStatusFilter.setFilterContainerClass('margin-neg');
        this.publishStatusFilter.setTagContainerId('selected-publish_statuses');
        this.publishStatusFilter.setTagContainerCaption('Selected publish statuses:');

        this.syncStatusFilter = new multipleSelector_template("syncStatusFilter", this.getTemplateViewModel(), this.caller);
        this.syncStatusFilter.setLabel("sync status");
        this.syncStatusFilter.setFilterContainerClass('margin-neg');
        this.syncStatusFilter.setTagContainerId('selected-sync_statuses');
        this.syncStatusFilter.setTagContainerCaption('Selected sync statuses:');

        this.templateFilter = new multipleSelector_template("templateFilter", this.getTemplateViewModel(), this.caller);
        this.templateFilter.setLabel("type");
        this.templateFilter.setFilterContainerClass('margin-neg');
        this.templateFilter.setTagContainerId('selected-templates');
        this.templateFilter.setTagContainerCaption('Selected types:');

        this.classificationFilter = new multipleSelector_template("classificationFilter", this.getTemplateViewModel(), this.caller);
        this.classificationFilter.setLabel("Classification");
        this.classificationFilter.setFilterContainerClass('margin-neg');
        this.classificationFilter.setTagContainerId('selected-classifications');
        this.classificationFilter.setTagContainerCaption('Selected Classifications:');

        this.networkCategoryFilter = new multipleSelector_template("networkCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoryFilter.setLabel("network category");
        this.networkCategoryFilter.setFilterContainerClass('margin-neg');
        this.networkCategoryFilter.setTagContainerId('selected-network_categories');
        this.networkCategoryFilter.setTagContainerCaption('Selected network categories:');

        this.contentTypeFilter = new multipleSelector_template("contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass('margin-neg');
        this.contentTypeFilter.setTagContainerId('selected-content_types');
        this.contentTypeFilter.setTagContainerCaption('Selected content types:');

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel("category");
        this.categoryFilter.setFilterContainerClass('margin-neg');
        this.categoryFilter.setTagContainerId('selected-categories');
        this.categoryFilter.setTagContainerCaption('Selected categories:');

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("Intent");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected Intents:');

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('articles');

        this.pageViews24HrsChart = new amCharts_v4_date_line_template("amCharts_v4_date_pageViews24Hrs_line_template", this.getTemplateViewModel(), this.caller);
        this.pageViews24HrsChart.setXAxisRotation(-90);
        this.pageViews24HrsChart.setXAxisFontSize(14);


        this.shortTermReportChart = new amCharts_v4_date_line_template("amCharts_v4_date_STRList_line_template", this.getTemplateViewModel(), this.caller);
        this.shortTermReportChart.setXAxisRotation(-90);
        this.shortTermReportChart.setXAxisFontSize(14);

        this.shortTermReportTooltip = new infoButton_template('shortTermReportTooltip', this.getTemplateViewModel(), this.caller)
        this.shortTermReportTooltip.setTitle('Performance');
        this.shortTermReportTooltipContent = `<ul>
        <li>Views count each load of an article, including if it is loaded as part of the infinite scroll experience.</li>
        <li>Visits count each load of an article where a user navigated from an external source.</li>
        <li>Engagements indicates the percentage of users that navigated to a depth of at least 1600 pixels in the article.</li> </ul>`
        this.shortTermReportTooltip.setContent(this.shortTermReportTooltipContent);
    }

    protected getTemplateName(): string{
        return "articlesList-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return{
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("DESC"),
            brand: ko.observable(""),
            articles: ko.observableArray([]),
            lockedArticles: ko.observableArray([]),
            orderByAndDirection: ko.observable("dateLastPublishStatus_DESC"),
            isAddButtonShown: ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['article_list_self', 'article_list_brand', 'article_edit_publishingControl', 'trash_articles_tool'])),
            isVisibleUpdateColumnPreferences: ko.observable(false),
            arrayShowColumns: ko.observableArray([]),
            columnPreference: ko.observableArray([]),
            pageViews24Hrs: ko.observableArray([]),
            shortTermReportIsPublished: ko.observable(false),
            shortTermReportIdArticle: ko.observable(),
            shortTermReportRange: ko.observable("day"),
            shortTermReportTooltip: ko.observable(null),
            isOnWatchlist: ko.observable(false),
            watchlistButtonEnabled: ko.observable(false),
            lastRefreshedCounter: ko.observable(0),

            trashedArticlesFormShown: ko.observable(false),
            trashedArticlesFormIsLoading: ko.observable(false),
            trashedArticlesFiles: ko.observableArray([]),
            trashedArticlesSummary: ko.observable(null),
            trashedArticlesFormError : ko.observable([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd();
            },
            onClickView: (data, event) => {
                self.onClickView(data.id, event);
            },
            onClickViewOnSite: (data, event) => {
                self.onClickViewOnSite(data);
            },
            onClickViewOnSiteAMP: (data, event) => {
                self.onClickViewOnSiteAMP(data);
            },
            checkShowColumnPreference: (data, event) => {
                return self.checkShowColumnPreference(data);
            },
            onClickShowEditColumnPreferences: (data, event) => {
                return self.onClickShowEditColumnPreferences(data);
            },
            onClickSaveColumnPreferences: (data, event) => {
                self.onClickSaveColumnPreferences();
            },
            onClickShowChart: (data, event) => {
                self.onClickShowChart(data);
            },
            onClickHideChart: (data, event) => {
                self.onClickHideChart();
            },
            onClick7DayView: function (value, data,event){
                self.onClick7DayView();
            },
            onClick1DayView: function (value, data,event){
                self.onClick1DayView();
            },
            onClickRefresh: function (value, data,event){
                self.onClickRefresh();
            },
            onClickShortTermReportPreferences: (data, event) => {
                return self.onClickShortTermReportPreferences();
            },
            onClickEditWatchlist: function (value, data, event){
                self.onClickEditWatchlist(value, data);
            },

            onClickToggleTrashedArticlesForm : function () {
                self.toggleTrashedArticlesForm();
            },

            onClickUploadTrashedArticlesFiles : function () {
                self.uploadTrashedArticlesFiles();
            },

            onChangeTrashedArticlesForm : function (element) {
                self.trashedArticlesFormChanged(element);}
        };
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest(){

        return {
            orderBy : this.viewModel.list.orderBy,
            orderByDirection : this.viewModel.list.orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'articles',
            filters      : {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                authors: this.authorFilter.getUsersForRequest(),
                editors: this.editorFilter.getUsersForRequest(),
                status: this.getTemplateViewModel().statusFilter.selectedItems,
                publishStatus: this.getTemplateViewModel().publishStatusFilter.selectedItems,
                syncStatus: this.getTemplateViewModel().syncStatusFilter.selectedItems,
                template: this.getTemplateViewModel().templateFilter.selectedItems,
                classification: this.getTemplateViewModel().classificationFilter.selectedItems,
                networkCategory: this.getTemplateViewModel().networkCategoryFilter.selectedItems,
                intent: this.getTemplateViewModel().intentFilter.selectedItems,
                contentType: this.getTemplateViewModel().contentTypeFilter.selectedItems,
                category: this.getTemplateViewModel().categoryFilter.selectedItems,
                tags: this.tagFilter.getTagsForRequest(),
                hideColumns: this.getTemplateViewModel().columnPreference()
            },
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.articlesListReorder();
    }

    public onClickAdd(){

        this.caller.addArticle();
    }

    public onClickView(id, event){
        if(event.target.id.indexOf("site-view") == -1){
            this.caller.viewArticle(id);
        }
    }

    public onClickViewOnSite(data){

        let brand = this.getTemplateViewModel().brand();
        if(data.idPublishStatus == 1 || data.idPublishStatus == 2){
            this.caller.previewArticle(data,brand);
        }else{
            this.caller.viewArticleOnSite(data,brand);
        }
        return false;
    }

    public onClickViewOnSiteAMP(data){

        let brand = this.getTemplateViewModel().brand();
        if(data.idPublishStatus == 1 || data.idPublishStatus == 2){
            this.caller.previewArticleAMP(data,brand);
        }else{
            this.caller.viewArticleOnSiteAMP(data,brand);
        }
        return false;
    }

    public setDefaultStatusFilters(): void {

        let trashStatus = 7;
        let statusString = "";
        let statusItems = this.statusFilter.getItems();

        statusItems.forEach((i) => {
            if (i['id'] != trashStatus) {
                statusString = statusString + "," + i['id'];
            }
        });
        if(statusString != ""){
            statusString = statusString.substring(1);
        }

        this.setFilterSelectedItems(this.statusFilter, statusString);

        this.hideColumnsFromUrl(null);
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    private setTagPreset(idTag:number, tag: string): void {

        this.tagFilter.getTemplateViewModel().idTag(idTag);
        this.tagFilter.getTemplateViewModel().tag(tag);
        this.tagFilter.toggleCloseButton();
    }

    private setUserPresetFilter(userFilter: filterUser_template, idUser?: number, name?: string): void {

        userFilter.getTemplateViewModel().idUser(idUser);
        userFilter.getTemplateViewModel().user(name);
        userFilter.toggleCloseButton();
    }

    public setLockedArticles(lockedArticles: Array<any>): void {

        this.getTemplateViewModel().lockedArticles(lockedArticles);
    }


    public setArticles(articles: Array<{ title: string, author: string, dateCreated: string, id: string , reference: string}>): void {

        this.getTemplateViewModel().articles(articles);
    }


    public setAddButtonShown(isAddButtonShown: boolean){

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setStatusFilterItems(items){

        this.statusFilter.setItems(items);
    }

    public setIntentFilterItems(items){

        this.intentFilter.setItems(items);
    }

    public setPublishStatusFilterItems(items){

        this.publishStatusFilter.setItems(items);
    }

    public setSyncStatusFilterItems(items){

        this.syncStatusFilter.setItems(items);
    }

    public setTemplateFilterItems(items){

        this.templateFilter.setItems(items);
    }

    public setClassificationFilterItems(items){

        this.classificationFilter.setItems(items);
    }

    public setNetworkCategoryFilterItems(groupCategories){

        let groups = [];
        for ( let groupCategory of groupCategories){

            groups.push({"name" : groupCategory.name, "items" :groupCategory.networkCategories});
        }
        this.networkCategoryFilter.setMultiSectionItems(groups);
    }
    public setContentTypeFilterItems(items){

        this.contentTypeFilter.setItems(items);
    }

    public setCategoryFilterItems(items){

        this.categoryFilter.setItems(items);
    }

    public setAuthorFilter(users) {

        this.authorFilter.setUsers(users);
    }

    public setEditorFilter(users) {

        this.editorFilter.setUsers(users);
    }

    protected setTagFilter(tags) {

        this.tagFilter.setTags(tags);
    }

    public setPermissions(permissions) {

        this.authorFilter.setIsVisible(permissions.article_list_brand.read);

        this.getTemplateViewModel().permissions(permissions);
    }

    public setBrand(brand) {

        this.getTemplateViewModel().brand(brand);
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public checkShowColumnPreference(columnName): boolean{

        let showColumn = this.getTemplateViewModel().columnPreference();

        if (showColumn.length > 0){

            let columnPreferences = this.getTemplateViewModel().columnPreference();
            return columnPreferences[columnName] == null || columnPreferences[columnName];
        }

        return true;
    }

    public onClickShowEditColumnPreferences(data){

        let columnPreferences = {"dateUpdated" : true, "dateScheduled" : true, "dateOriginalPublish" : true, "dateLastPublish" : true, "syncStatus" : true,
            "articleStatus" : true, "template" : true, "networkCategory" : true, "intent" : true, "contentType" : true};

        let currentColumns = this.getTemplateViewModel().columnPreference();
        for (let key in currentColumns) {
            columnPreferences[key] = currentColumns[key];
        }

        this.getTemplateViewModel().arrayShowColumns(columnPreferences);
        this.getTemplateViewModel().isVisibleUpdateColumnPreferences(data);
    }

    public onClickSaveColumnPreferences(){

        this.getTemplateViewModel().columnPreference(this.getTemplateViewModel().arrayShowColumns());

        //Modify URL to reflect changes
        this.updateUrlParameter("hideColumns", this.getTemplateViewModel().columnPreference());

        this.getTemplateViewModel().isVisibleUpdateColumnPreferences(false);
    }

    public onClickShortTermReportPreferences(){

        this.onClickSaveColumnPreferences();
        return true;
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // Multi select filters.
            this.setFilterSelectedItems(this.statusFilter, urlParams.status);
            this.setFilterSelectedItems(this.categoryFilter, urlParams.category);
            this.setFilterSelectedItems(this.templateFilter, urlParams.template);
            this.setFilterSelectedItems(this.syncStatusFilter, urlParams.syncStatus);
            this.setFilterSelectedItems(this.contentTypeFilter, urlParams.contentType);
            this.setFilterSelectedItems(this.publishStatusFilter, urlParams.publishStatus);
            this.setFilterSelectedItems(this.networkCategoryFilter, urlParams.networkCategory);
            this.setFilterSelectedItems(this.classificationFilter, urlParams.classification);
            this.setFilterSelectedItems(this.intentFilter, urlParams.intent);

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType)
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            // keyword filter.
            let keywordString = urlParams.keywords
            if(urlParams.keywords){
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filter.getTemplateViewModel().filterKeyword(keywordString);

            // tag filter.
            let nameString = "";
            if(urlParams.tags) {
                this.tagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
            } else {
                this.tagFilter.resetTagContainer();
            }

            // user filters.
            if(urlParams.authors) {
                this.authorFilter.setSelectedUsersFromRequestParams(urlParams.authors);
            } else {
                this.authorFilter.resetTagContainer();
            }

            if(urlParams.editors){
                this.editorFilter.setSelectedUsersFromRequestParams(urlParams.editors);
            } else {
                this.editorFilter.resetTagContainer();
            }

            //Hide columns
            this.hideColumnsFromUrl(urlParams.hideColumns);
        }
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(Array.isArray(urlParams)){
            urlParams = urlParams.toString();
        }
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {

                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public hideColumnsFromUrl(urlParam){

        let columnPreferences = {"dateUpdated" : true, "dateScheduled" : true, "dateOriginalPublish" : true, "dateLastPublish" : true, "syncStatus" : true,
            "articleStatus" : true, "template" : true, "networkCategory" : true, "intent" : true, "contentType" : true};

        if(urlParam){

            let columnsToHide = urlParam;
            if(!Array.isArray(urlParam)){
                columnsToHide = urlParam.split(",");
            }
            if(Array.isArray(columnsToHide)){
                columnsToHide.forEach((column) => {
                    columnPreferences[column] = false
                })
            }else if(columnsToHide && columnsToHide != ""){
                columnPreferences[columnsToHide] = false
            }
        }

        this.getTemplateViewModel().columnPreference(columnPreferences);
    }

    public updateUrlParameter(urlParamName, columnPreferences){

        let preferenceString = "";
        let hasColumnPreference = false;
        Object.keys(columnPreferences).forEach((preference) => {
            if(columnPreferences[preference] == false){
                hasColumnPreference = true;
                preferenceString = preferenceString + preference + ",";
            }
        })
        if (preferenceString.length > 0){
            preferenceString = "hideColumns=" + preferenceString.slice(0, -1);
        }

        let queryString = window.location.href.split('?')[1];
        queryString = decodeURIComponent(queryString);

        let urlParamsSections = queryString.split("&");
        urlParamsSections.unshift(preferenceString);

        let newUrl = window.location.href.split('?')[0] + "?";
        let canHideColumns = true;

        urlParamsSections.forEach((paramSection) => {
            if(paramSection.startsWith("hideColumns=")){

                if(hasColumnPreference && canHideColumns){

                    canHideColumns = false;
                    if(preferenceString != ""){

                        newUrl = newUrl + encodeURIComponent(preferenceString + "&");
                    }
                }
            }else{

                if(paramSection != ""){
                    newUrl = newUrl + encodeURIComponent(paramSection + "&");
                }
            }
        })

        //To replace the %2C or %3F that is the encoded extra & or ?
        newUrl = newUrl.slice(0, -3);

        window.history.replaceState('', '', newUrl)
    }


    public onClickShowChart(data){

        let idArticle = data.id;
        let reportData = null;

        let pageViews24Hrs = this.getTemplateViewModel().pageViews24Hrs();

        if(pageViews24Hrs){

            this.getTemplateViewModel().pageViews24Hrs().forEach(item=>{
                if(item["data"] && item["data"][0].idArticle == idArticle){
                    reportData = item["data"];
                }
            });

            this.getTemplateViewModel().shortTermReportIdArticle(idArticle);

            this.onClick1DayView();

            document.getElementById('articleList-chart').classList.add('is-visible');
            document.body.classList.add('is-fixed');
        }
    }

    public onClickHideChart(){

        document.getElementById('articleList-chart').classList.remove('is-visible');
        document.body.classList.remove('is-fixed');
    }

    public setShortTermReport(shortTermReport): void {

        this.getTemplateViewModel().shortTermReportIsPublished(!!shortTermReport["publishDate"]);
        this.shortTermReportChart.setDate('date');
        this.shortTermReportChart.setMinGridDistance(20);

        if(this.getTemplateViewModel().shortTermReportRange() == "day"){

            this.shortTermReportChart.setInterval([
                {timeUnit: "minute", count: 5}
            ]);
        }else{

            this.shortTermReportChart.setInterval([
                {timeUnit: "hour", count: 1}
            ]);
        }

        // set y axis
        let yaxis = [];

        yaxis.push({
            field: "viewCount",
            name:  'Views',
            axis: "main",
            color: "#6e3dbb",
            opposite: false,
            bullet: "none"
        });

        yaxis.push({
            field: "visitCount",
            name:  'Visits',
            axis: "main",
            color: "#009888",
            fillOpacity: 0.5,
            opposite: false,
            bullet: "none"
        });

        yaxis.push({
            field: "depthMarkerCount",
            name:  'Engagements',
            axis: "main",
            color: "#268af9",
            opposite: false,
            bullet: "none",
            tooltipText: "{name}: [bold]{valueY} ({engagementRate}%)[/]",
            calculatePercent: true
        });

        this.shortTermReportChart.setYaxis(yaxis);

        let ranges = [];
        //Get publish dates
        let publishDate = shortTermReport["publishDate"];
        if(publishDate){

            ranges = [{
                publishDate: publishDate,
                publishType: "first"
            }];

            let republishes = shortTermReport["republishDates"];
            republishes.forEach(item=>{
                if(item.republishDate){
                    ranges.push({publishDate: item.republishDate, publishType: "republish"});
                }
            });
        }

        this.shortTermReportChart.setRanges(ranges);

        this.shortTermReportChart.drawChart(shortTermReport["data"]);

        this.shortTermReportChart.show();

        this.getTemplateViewModel().lastRefreshedCounter(0);
        let _this = this;
        clearInterval(0);
        setInterval(function() {
            let counter = _this.getTemplateViewModel().lastRefreshedCounter();
            if(!isNaN(counter)){

                counter++;
                _this.getTemplateViewModel().lastRefreshedCounter(counter);
            }
        }, 1000*60*5);

        this.setIsOnWatchlist(shortTermReport["isWatchlisted"]);
        this.getTemplateViewModel().watchlistButtonEnabled(true);
    }

    public onClick7DayView(){

        this.getTemplateViewModel().shortTermReportRange("week");
        this.caller.getShortTermReport(this.getTemplateViewModel().shortTermReportIdArticle());
    }
    public onClick1DayView(){

        this.getTemplateViewModel().shortTermReportRange("day");
        this.caller.getShortTermReport(this.getTemplateViewModel().shortTermReportIdArticle());
    }
    public onClickRefresh(){

        this.caller.getShortTermReport(this.getTemplateViewModel().shortTermReportIdArticle());
    }

    public onClickEditWatchlist(isAddToWatchlist, data){
        this.getTemplateViewModel().watchlistButtonEnabled(false);
        this.caller.editWatchlist(isAddToWatchlist, this.getTemplateViewModel().shortTermReportIdArticle());
    }

    public setIsOnWatchlist(isOnWatchlist){
        this.getTemplateViewModel().isOnWatchlist(isOnWatchlist);
    }


    toggleTrashedArticlesForm(){
        const caller = this.caller;
        this.getTemplateViewModel().trashedArticlesFormShown(!this.getTemplateViewModel().trashedArticlesFormShown());
        if (!this.getTemplateViewModel().trashedArticlesFormShown()){
            this.resetTrashCsvForm();
            //Abort the summary request because it can be time-consuming
            caller.abortCsvSummaryRequest()
        }
    }

    private resetTrashCsvForm() {
        const csvTrashedArticlesInput = document.querySelector(`#csvFileInput`) as HTMLInputElement
        csvTrashedArticlesInput.value = "";
        this.getTemplateViewModel().trashedArticlesFiles([]);
        this.getTemplateViewModel().trashedArticlesSummary(null);
        this.getTemplateViewModel().trashedArticlesFormError([]);
    }

    /**
     * Sets the error message for the trashed article form.
     *
     * @param {Array<string>} message - An array of error messages.
     * @returns {void}
     */
    public setTrashedArticleFormErrorMessage(message: Array<string>): void {
        this.getTemplateViewModel().trashedArticlesFormError({messages: ko.observableArray(message)});
    }

    /**
     * Uploads trashed articles files.
     *
     * @return {Promise} A promise that resolves when trashed articles files are uploaded.
     */
    async uploadTrashedArticlesFiles(): Promise<any>{
        const caller = this.caller;
        await caller.uploadTrashedArticlesFiles();
    }


    async trashedArticlesFormChanged(element){

        this.getTemplateViewModel()
            .trashedArticlesFormError([])
            .trashedArticlesFiles([])
            .trashedArticlesSummary(null)

        const files = element.files;
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                this.getTemplateViewModel().trashedArticlesFiles.push(files[i]);
                break
            }

            const caller = this.caller
            await caller.getTrashedArticlesFilesSummary();
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articlesList_template.ts